import coreAPIInstance from "./coreApiInstance";

export const tournamentConfigAPIs = {
  getOrCreateTournamentConfig: ({ payload }) => coreAPIInstance.post("/api/v1/tournament-config", payload),
  updateTournamentConfig: ({ payload, tournamentId }) =>
    coreAPIInstance.patch(`/api/v1/tournament-config/${tournamentId}`, payload),
  testTournamentConfigReplayDetection: ({ payload }) =>
    coreAPIInstance.post("/api/v1/tournament-config/replay-detection.test", payload),
  triggerStreamReplayDetection: ({ payload }) =>
    coreAPIInstance.post("/api/v1/tournament-config/replay-detection.stream", payload),
  testTournamentConfigLLMOCR: ({ payload }) => coreAPIInstance.post("/api/v1/tournament-config/llm-ocr.test", payload),
};
